import React from 'react';
import type { PageDetailOut } from '../../types/catalog';
import { ReviewGridV2Renderer } from '../../components/templates/ReviewGridV2Renderer';

/** phonics.review_grid.v2: delegates to ReviewGridV2Renderer (meta pills, grid by item_type, word image/placeholder, Play All). */
export const PhonicsReviewGridV2: React.FC<{ page: PageDetailOut; onComplete?: () => void }> = ({
  page,
}) => {
  return <ReviewGridV2Renderer page={page} />;
};
